<template>
  <div class="the-sidebar">
    <div
      class="begin xl:h-screen 2xl:h-screen 2xl:w-80 xl:w-64 bg-[#FEFBF6] relative transition-all duration-300"
      :class="{ 'is-little': isCollapsed }"
    >
      <div
        class="cursor-pointer absolute -right-4 top-10 z-50 bg-[#FABC1D] rounded-full shadow-lg p-1 hover:scale-110 transition-transform"
        @click="$emit('toggle')"
      >
        <icon
          :data="icons.ic_reduce"
          original
          width="24"
          height="24"
          :class="{ 'rotate-180': isCollapsed }"
          class="transition-transform duration-300"
        ></icon>
      </div>

      <div
        class="side_menu_container p-4 lg:h-[90vh] xl:h-[90vh] 2xl:h-[93vh] overflow-y-scroll"
      >
        <div class="xl:mt-6 2xl:mt-12">
          <div
            v-if="!isCollapsed"
            class="ml-4 text-[#5C5E64] font-medium text-xs mb-4 uppercase tracking-wider"
          >
            Informations
          </div>
          <div v-else class="h-8"></div>

          <side-menu-element
            v-if="user.role === 'admin'"
            menu="Tableau de bord"
            :icon="icons.ic_dashboard"
            path="dashboard"
            :is-little="isCollapsed"
          ></side-menu-element>
          <side-menu-element
            v-if="user.role === 'admin'"
            menu="Transactions"
            :icon="icons.ic_estimate"
            path="transactions"
            :is-little="isCollapsed"
          ></side-menu-element>
          <side-menu-element
            v-if="user.role === 'admin'"
            menu="Ticket gratuit"
            :icon="icons.ic_product"
            path="participant"
            :is-little="isCollapsed"
          ></side-menu-element>
          <side-menu-element
            v-if="user.role === 'promoteur'"
            menu="Filleuls"
            :icon="icons.ic_client"
            path="filleul"
            :is-little="isCollapsed"
          ></side-menu-element>
          <side-menu-element
            v-if="user.role === 'admin'"
            menu="Newsletters"
            :icon="icons.ic_client"
            path="newsletter"
            :is-little="isCollapsed"
          ></side-menu-element>
        </div>

        <div class="mt-8">
          <div
            v-if="!isCollapsed"
            class="ml-4 text-[#5C5E64] font-medium text-xs mb-4 uppercase tracking-wider"
          >
            Management
          </div>
          <div v-else class="h-8"></div>

          <side-menu-element
            v-if="user.role === 'admin'"
            menu="Panelistes"
            :icon="icons.ic_product"
            path="panelist"
            :is-little="isCollapsed"
          ></side-menu-element>
          <side-menu-element
            v-if="user.role === 'admin'"
            menu="Partenaires"
            :icon="icons.ic_user"
            path="partners"
            :is-little="isCollapsed"
          ></side-menu-element>
          <side-menu-element
            v-if="user.role === 'admin'"
            menu="Sujets"
            :icon="icons.ic_product"
            path="subjects"
            :is-little="isCollapsed"
          ></side-menu-element>
          <side-menu-element
            v-if="user.role === 'admin'"
            menu="Présentations"
            :icon="icons.ic_product"
            path="presentations"
            :is-little="isCollapsed"
          ></side-menu-element>
          <side-menu-element
            v-if="user.role === 'admin'"
            menu="Candidatures Speakers"
            :icon="icons.ic_product"
            path="speaker-applications"
            :is-little="isCollapsed"
          ></side-menu-element>
          <side-menu-element
            v-if="user.role === 'admin'"
            menu="Inscriptions Hackathon"
            :icon="icons.ic_product"
            path="hackathon-applications"
            :is-little="isCollapsed"
          ></side-menu-element>
          <side-menu-element
            v-if="user.role === 'admin'"
            menu="Propositions Dev Day"
            :icon="icons.ic_product"
            path="devday-proposals"
            :is-little="isCollapsed"
          ></side-menu-element>
          <side-menu-element
            v-if="user.role === 'admin'"
            menu="Inscriptions Dev Day"
            :icon="icons.ic_product"
            path="devday-registrations"
            :is-little="isCollapsed"
          ></side-menu-element>
          <side-menu-element
            v-if="user.role === 'admin'"
            menu="Promoteurs"
            :icon="icons.ic_user"
            path="admin"
            :is-little="isCollapsed"
          ></side-menu-element>
          <side-menu-element
            v-if="user.role === 'promoteur'"
            menu="Mot de passe"
            :icon="icons.ic_user"
            path="updatePassword"
            :is-little="isCollapsed"
          ></side-menu-element>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ic_reduce from "@/assets/icons/ic_reduce-menu.svg";
import SideMenuElement from "@/components/helper/side-menu-element.vue";
import ic_dashboard from "@/assets/icons/ic_dashboard-menu.svg";
import ic_estimate from "@/assets/icons/ic_estimate-menu.svg";
import ic_client from "@/assets/icons/ic_client-menu.svg";
import ic_webhook from "@/assets/icons/ic_webook-menu.svg";
import ic_insurer from "@/assets/icons/ic_insurer-menu.svg";
import ic_product from "@/assets/icons/ic_product-insurance-menu.svg";
import ic_stat from "@/assets/icons/ic_menu-stats.svg";
import ic_user from "@/assets/icons/ic_user-menu.svg";
import ic_statistic from "@/assets/icons/ic_menu-stats.svg";
import store from "@/store";

export default {
  name: "the-sidebar",
  components: {
    SideMenuElement,
  },
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icons: {
        ic_reduce,
        ic_client,
        ic_estimate,
        ic_dashboard,
        ic_webhook,
        ic_insurer,
        ic_product,
        ic_stat,
        ic_user,
        ic_statistic,
      },
    };
  },
  computed: {
    user() {
      return store.state.user || {};
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/sass/variables";
.svg-fill {
  fill: transparent;
}
.begin {
  box-shadow: 4.549898147583008px 2.274949073791504px 5.68737268447876px 0
    #0000000d;
}
.is-little {
  width: 7.3rem !important;
}
::-webkit-scrollbar {
  width: 0; /* Largeur de la barre de défilement */
}

/* Poignée de la barre de défilement */
::-webkit-scrollbar-thumb {
  background: #888; /* Couleur de la poignée */
}

.begin {
  scrollbar-width: none;
  scrollbar-color: #888 #f0f0f0;
}
</style>
